import { fetchPriceTaxesData } from 'UserRegistration/resources/api/configurationData';

export function calculateTotal(registrationData, setRegistrationData) {

    const registrationDataCopy = Object.assign({}, registrationData);

    // If the subtotal has changed, we need to recalculate the taxes amounts as well
    fetchPriceTaxesData(registrationDataCopy).then((response) => {

        if (response) {

            // Set the sub-total amount
            registrationDataCopy.priceTaxesInfo.subTotal = response.subTotal;

            // Set the total amount
            registrationDataCopy.priceTaxesInfo.total = response.total;

            // Set the total amount BEFORE taxes
            registrationDataCopy.priceTaxesInfo.totalBeforeTaxes = response.totalBeforeTaxes;

            // Set the next payment total
            registrationDataCopy.priceTaxesInfo.recurringSubTotal = response.recurringSubTotal;

            // Set the volume discount amount
            registrationDataCopy.priceTaxesInfo.discountAmount = response.userRegistrationDiscountInformationDto.volumeDiscountAmount;

            // Set the volume discount percentage (does not include promo code discount)
            registrationDataCopy.priceTaxesInfo.discountPercentage = response.userRegistrationDiscountInformationDto.volumeDiscountPercentage;
            
            // Amount discounted by the provided promo code.
            registrationDataCopy.priceTaxesInfo.promoDiscountAmount = response.userRegistrationDiscountInformationDto.promoCodeDiscountAmount;

            // Empty the taxes list before adding in
            registrationDataCopy.priceTaxesInfo.taxes = [];

            response.macTaxInfoDetails.forEach((taxInfo) => {
                registrationDataCopy.priceTaxesInfo.taxes.push({
                    name: taxInfo.taxName,
                    rate: taxInfo.taxRate,
                    amount: taxInfo.taxAmount
                });
            });

        }

        setRegistrationData(registrationDataCopy);

    });
}

export function synchronizeSelectedSubscriptionItems(registrationData, packageSelectorData) {

    const selectedGroupKey = registrationData.registrationModel.subscription.selectedGroup.groupKey;

    // reset group selections
    packageSelectorData.availableSubscriptionItemGroups
        .filter(otherGroup => otherGroup.groupKey != selectedGroupKey)
            .forEach(otherGroup => {
                registrationData.selectedSubscriptionItems[otherGroup.groupKey] = [];
    }); 

    // loop through all item keys of the currently-selected group
    registrationData.registrationModel.subscription.selectedGroup.selectedSubscriptionAssociatedItemKeys.forEach((selectedItemKey) => {

        // Then, for each OTHER group
        packageSelectorData.availableSubscriptionItemGroups
            .filter(otherGroup => otherGroup.groupKey != selectedGroupKey)
                .forEach((otherGroup) => {

                    const match = otherGroup.subscriptionItems.find(item => item.associatedItemKey == selectedItemKey);
                   
                    if (match) {
                        registrationData.selectedSubscriptionItems[otherGroup.groupKey].push(match.id);
                    }                

                });
    });

    return registrationData;

}

/**
 * Extract the list of *enabled* Item IDs from the list of selected item ids
 * @param {*} selectedSubscriptionItemIds 
 * @param {*} packageSelectorData 
 * @returns 
 */
export function getEnabledItemIds(selectedSubscriptionItemIds, packageSelectorData) {

    let itemIdsToReturn = Object.assign([], selectedSubscriptionItemIds);

    // loop through all "selected subscription item ids"
    selectedSubscriptionItemIds.forEach((selectedItemId) => {

        // then loop through each sub item group
        packageSelectorData.availableSubscriptionItemGroups
            .forEach((group) => {

                // if this item is in our selected list, and it is disabled
                const disabledItem = group.subscriptionItems.find((item) => (item.id == selectedItemId) && !item.enabled);

                if (disabledItem) {
                    itemIdsToReturn.splice(itemIdsToReturn.indexOf(disabledItem.id), 1);
                }                       

        });

    });

    return itemIdsToReturn;
}


/**
 * Find the associated item keys for the list of given item ids
 * @param {*} selectedItemIds 
 * @param {*} packageSelectorData 
 * @returns 
 */
export function getSelectedItemAssociatedKeys(selectedItemIds, packageSelectorData) {

    let selectedKeys = [];

    packageSelectorData.availableSubscriptionItemGroups.forEach((group) => {

        group.subscriptionItems.filter((item) => selectedItemIds.includes(item.id))
            .forEach((item) => {

                selectedKeys.push(item.associatedItemKey);

        });

    });

    return selectedKeys;
}

export function isPromoCodeApplicable(registrationData) {
    // Do we have a list of supported items? If not, promo not available.
    if (!registrationData.registrationModel.promotion.supportedSubscriptionItems) {
        return false;
    }

    // We only want to display a promo code field if the user has made a 
    // selection and that selection does not only contain a free package.
    if (registrationData.registrationModel.selectedSubscriptionPackage) {
        if(registrationData.registrationModel.selectedSubscriptionPackage.freePackage 
            && !registrationData.registrationModel.selectedSecondarySubscriptions.length) {
            return false;
        }
    }

    // Next lets check if the selected frequency is in our supported list
    var frequencyNotAvailable = registrationData.registrationModel.promotion.supportedSubscriptionItems[registrationData.registrationModel.subscription.selectedFrequency] === undefined;

    if (frequencyNotAvailable) {
        return false;
    }

    // So we have supported items AND our selected frequency is in the list.
    // We need to check if the users selected subscription items are supported.
    var supportedItemsForSelectedFrequency = 
        registrationData.registrationModel.promotion.supportedSubscriptionItems[registrationData.registrationModel.subscription.selectedFrequency];

    // If we have some selected ids, lets look for those in the supported items.
    if (registrationData.registrationModel.subscription.selectedGroup.selectedSubscriptionItemIds.length 
        || registrationData.registrationModel.selectedSecondarySubscriptions.length) {
        /*
        * Merge regular subscription IDs (invoiceItemIDs) with secondary subscription IDs (they are all just subscription item IDs on the server side).
        * Private Construction on MERX is an example of a package selector sub component that can allow the user to choose a secondary subscription ID.
        */
        const subscriptionIds = registrationData.registrationModel.subscription.selectedGroup.selectedSubscriptionItemIds.concat(registrationData.registrationModel.selectedSecondarySubscriptions.map((item) => {
            return item.id;
        }));

        for (var i = 0; i < subscriptionIds.length; i++) {
            var selectedId = parseInt(subscriptionIds[i]);
            if (supportedItemsForSelectedFrequency.includes(selectedId)) {
                return true;
            }
        }
    } else if (registrationData.registrationModel.selectedSubscriptionPackage) { // If we don't have any of the ids, lets check if at least one is supported for promo.
        var itemIsSupported = false;
        for (var x = 0; x < registrationData.registrationModel.selectedSubscriptionPackage.subscriptionItems.length; x++) {
            if (supportedItemsForSelectedFrequency.includes(registrationData.registrationModel.selectedSubscriptionPackage.subscriptionItems[x].id)) {
                itemIsSupported = true;
                break;
            }
        }
        return itemIsSupported;
    }

    return false;
}
